import {
  PREORDER_REQUEST,
  PREORDER_ERROR,
  PREORDER_SUCCESS,
  PREORDER_PAYMENT_REQUEST,
  PREORDER_PAYMENT_ERROR,
  PREORDER_PAYMENT_SUCCESS,
  PREORDER_CALLBACK_SUCCESS,
  PREORDER_CALLBACK_ERROR,
  PREORDER_INITIALIZE,
  PREORDER_STATUS_INITIAL,
  PREORDER_STATUS_INPROGRESS,
  PREORDER_STATUS_SUCCESS,
  PREORDER_STATUS_ERROR,
  PAYMENT_STATUS_INPROGRESS,
  PAYMENT_STATUS_SUCCESS,
  PAYMENT_STATUS_ERROR,
  CALLBACK_STATUS_SUCCESS,
  CALLBACK_STATUS_ERROR,
  SET_PREORDER_NOTIFICATION_METHOD,
  OPEN_PREORDER_PAYMENT_FORM,
  PREORDER_HAS_ONLINE_PAYMENT,
} from './constants';

const initialState = {
  status: null,
  paymentStatus: null,
  orderId: null,

  notificationMethod: null,
  paymentFormOpen: null,
  hasOnlinePayment: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PREORDER_REQUEST:
      return { ...state, status: PREORDER_STATUS_INPROGRESS };
    case PREORDER_SUCCESS: {
      const { orderId } = action;
      return { ...state, status: PREORDER_STATUS_SUCCESS, orderId };
    }
    case PREORDER_ERROR:
      return { ...state, status: PREORDER_STATUS_ERROR };

    case SET_PREORDER_NOTIFICATION_METHOD: {
      const { payload } = action;
      return { ...state, notificationMethod: payload };
    }
    case OPEN_PREORDER_PAYMENT_FORM:
      return { ...state, paymentFormOpen: true };

    case PREORDER_PAYMENT_REQUEST:
      return { ...state, status: PAYMENT_STATUS_INPROGRESS };
    case PREORDER_PAYMENT_SUCCESS: {
      const { action: actionUrl, data } = action;
      return {
        ...state,
        status: PAYMENT_STATUS_SUCCESS,
        paymentActionUrl: actionUrl,
        paymentData: data,
      };
    }
    case PREORDER_PAYMENT_ERROR:
      return { ...state, status: PAYMENT_STATUS_ERROR };
    case PREORDER_CALLBACK_SUCCESS: {
      const { contact, orderNumber } = action;
      return {
        ...state,
        status: CALLBACK_STATUS_SUCCESS,
        callbackContact: contact,
        callbackOrderId: orderNumber,
      };
    }
    case PREORDER_INITIALIZE:
      return { ...state, status: PREORDER_STATUS_INITIAL };
    case PREORDER_CALLBACK_ERROR: {
      const { contact, orderNumber } = action;
      return {
        ...state,
        status: CALLBACK_STATUS_ERROR,
        callbackContact: contact,
        callbackOrderId: orderNumber,
      };
    }
    case PREORDER_HAS_ONLINE_PAYMENT:
      return { ...state, hasOnlinePayment: true };
    default:
      return state;
  }
}
